<template>
    <ErrorPage code="400"
               status="Bad Request"
               :href="$urls.SUPPORT_TICKETS"
               href-text="Submit a support ticket"
               :refresh-link="true"
    />
</template>

<script>
  import ErrorPage from "../components/ErrorPage";

  export default {
    name: "ErrorBadRequest",
    components: {ErrorPage},
  }
</script>

<style scoped>
</style>
